import { ParamsGetOrderWorklist } from '@vindr/services/apis/order.api';

export const FILTER_TYPE: Record<string, keyof ParamsGetOrderWorklist> = {
  STATUS: 'statuses',
  PATIENT_ID: 'patient_id',
  PATIENT_NAME: 'patient_name',
  MODALITY: 'modalities',
  INSTITUTION_ID: 'institution_ids',
  STUDY_DESC: 'study_desc',
  VISIT_ID: 'visit_id',
  ACCESSION_NO: 'order_group',
  MATCH_STATUS: 'match_status',
  STUDY_ID: 'study_instance_uid',
  SCHEDULED_DATE: 'scheduled_date',
  ORDER_DATE: 'order_date',
  RECEIVED_AT: 'patient_arrived_time',
  ESIGN_STATUS: 'esign_status',
  LATEST_INDICATOR: 'latest_indicator',
  ASSIGN_TO: 'assign_to',
};

export const WORKLIST_COLUMNS_SETTING = 'col-worklist-custom';

export const WORKLIST_COLUMNS_ORIGINAL = 'col-worklist-default';
